import { Injectable, OnInit } from '@angular/core';
import { JwtService } from 'mclane-webauth-lib';

@Injectable({
    providedIn: 'root'
})
export class CommonService implements OnInit {
    ngOnInit(): void {
    }

    constructor(public jwtService: JwtService) {
    }

    public hasAccess(rolesArray: string[]) {
        if(rolesArray == null || this.jwtService.roles == null) { return false;}
        return rolesArray.some(r => this.jwtService.roles.includes(r));
    }

    public hasEveryAccess(rolesArray: string[]) {
        if(rolesArray == null || this.jwtService.roles == null) { return false;}
        return rolesArray.every(r => this.jwtService.roles.includes(r));
    }

}
